import styled from 'styled-components'
import { themeGet } from 'styled-system'

export const Header = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 1.2813rem;
  margin-top: 2.5rem;
  text-align: center;
`
export const SecondStepLogo = styled.img`
  height: 84px;
  width: 146.9px;
`
export const Title = styled.h2`
  font-size: 23px;
  font-family: ${themeGet('headerFontFamilySemibold')};
  color: ${themeGet('colors.secondStepBlue')};
  margin-top: 2.3125rem;
  margin-bottom: 0.9375rem;
`

export const Subtitle = styled.p`
  font-size: 16px;
  font-family: ${themeGet('textFontFamily')};
  color: ${themeGet('colors.darkGray')};
  line-height: 20px;
  margin-bottom: 0;
`
export const RegisteredTrademarkIcon = styled.span`
  font-size: 33px;
  vertical-align: bottom;
  line-height: 10px;
`
